import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../../hooks/use-insurance-api';
import { ProviderSelectionDialog } from '../../../shared/components/provider-selection-dialog/provider-selection-dialog';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';

export interface IButtonProps {
  onSuccess: () => Promise<void>;
  disabled?: boolean;
}

export const SelfPayButton: FC<IButtonProps> = (props) => {
  const { onSuccess, disabled } = props;
  const { showError, showSuccess } = useNotification();
  const { status, selfPayApptRequest } = useInsuranceApi();
  const { locationId, appointmentRequest, ivSummary, sendIvStatusUpdatedEvent, setIsLoading, providers } =
    useApptRequestIvStatusDialog();
  const [providerDialogOpen, setProviderDialogOpen] = useState(false);

  useEffect(() => {
    if (status.selfPayVerification.error) showError('Unable to perform the operation.');
  }, [status.selfPayVerification.error]);

  const updateInsuranceStatus = async () => {
    if (ivSummary?.idProvider) await performSelfPayRequest(ivSummary.idProvider);
    else setProviderDialogOpen(true);
  };

  const performSelfPayRequest = async (provId: number) => {
    setIsLoading(true);

    const success = await selfPayApptRequest(appointmentRequest!.id, locationId, provId);

    if (success) {
      showSuccess('IV status was updated successfully.');
      sendIvStatusUpdatedEvent('SelfPay');
      await onSuccess();
    }

    setIsLoading(false);
  };

  const handleProviderDialogSubmit = async (selectedProviderId: number) => {
    await performSelfPayRequest(selectedProviderId);
    setProviderDialogOpen(false);
  };

  const handleProviderDialogClose = () => {
    setProviderDialogOpen(false);
  };

  return (
    <Box>
      <LoadingButton
        disableElevation
        variant="outlined"
        color="primary"
        onClick={updateInsuranceStatus}
        loading={status.manualVerification.isRunning}
        disabled={disabled}
      >
        Self Pay
      </LoadingButton>
      <ProviderSelectionDialog
        open={providerDialogOpen}
        title="Self Pay - Choose Provider"
        providers={providers}
        onClose={handleProviderDialogClose}
        onSubmit={handleProviderDialogSubmit}
      />
    </Box>
  );
};
